module.exports = ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss-loader/lib??ref--1-1!./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css
// module id = 17
// module chunks = 0